module.exports = __webpack_public_path__ + "src/assets/models/molar/spoon_0_5.fbx";